import React, { useEffect, useState } from 'react'
import { Button, Card, Table } from 'react-bootstrap'
import planeicon from '../../../images/planeicon.svg'
import plane from "../../../images/plane100.png";

import BookTicket from '../../Modals/BookTicket';
import SigninPopup from '../../Modals/SigninPopup';
import { formatDate } from '../../../functions';
import { Link } from 'react-router-dom';


const TicketCard2 = ({ data, props }) => {
    const [modalShow, setModalShow] = React.useState(false);
    const [selectedPnr, setSelectedPnr] = useState({ date: '', pnr: '', price: 0, updated_at: '' });
    const [isLogin, setIsLogin] = useState(false);
    const [showSelectedSubparts, setShowSelectedSubparts] = useState(false);
    const [selectedSubpartIndex, setSelectedSubpartIndex] = useState(null);
    const [openId, setOpenId] = useState(null);

    useEffect(() => {
        let checkLogin = localStorage.getItem('token');
        if (checkLogin) {
            setIsLogin(true);
        }
    }, []);

    const handleShow = () => {
        let checkLogin = localStorage.getItem('token');
        if (checkLogin) {
            setIsLogin(true);
            setModalShow(true);
        } else {
            setIsLogin(false);
            setModalShow(true);
        }
    };

    const handleLoginSuccess = () => {
        // After a successful login, set isLogin to true and open the BookTicket popup.
        setIsLogin(true);
        setModalShow(true);
    };

    const ShowSubparts = (index) => {
        if (isLogin) {
            setShowSelectedSubparts((prev) => (index === selectedSubpartIndex ? !prev : true));
            setSelectedSubpartIndex(index);
        } else {
            handleShow()
        }
    }

    // console.log('openId=====>>>', openId);
    // console.log('TicketCard2sss   s=====>>>', props);
    return (
        <>
            {props?.length > 0 ? props?.map((val, index) => {
                return (
                    <Card className={'mb-4'}>
                        {/* <Card.Header className='p-0 m-0 border-0'>
                            <div className={'px-1 py-1 pb-0 d-flex align-items-center'}>

                                <div className={'d-flex align-items-center'}>
                                    <Link className={`iconlogo1`}>
                                        <img className="img-fluid h30" src={plane} alt="icon" />
                                    </Link>
                                </div>
                                <h5 className={'ms-2 titlehead'}>{val.sector}</h5>
                            </div>
                        </Card.Header> */}
                        <Card.Body className='px-0 py-1 pt-0'>
                            {/* <div className="shorting">

                                <h4 className="title">Sort By:</h4>

                                <ul className='flex-wrap align-items-center justify-content-between gap-4 mb-0'>
                                    <li>
                                        <div>Airline</div>
                                    </li>
                                    <li>
                                        <div>Route</div>
                                    </li>
                                    <li>
                                        <div>Departure Date</div>
                                    </li>
                                    <li>
                                        <div></div>
                                    </li>
                                    <li>
                                        <div>Price</div>
                                    </li>
                                </ul>

                            </div> */}

                            {val?.tickets?.map((pnr, i) => {
                                return (
                                    <div className="flight">

                                        {/* Top Section */}
                                        <div className="flight-info-div" key={i}>

                                            {/* Left Info */}
                                            <div className="flight-inr flex-grow-1">
                                                <ul className="list-unstyled">

                                                    {/* Airline */}
                                                    <li>
                                                        <div className="airline-name d-flex align-items-center">
                                                            <figure className="mb-0 me-2">
                                                                <img className={'img-fluid'} src={pnr?.air_line_logo} alt={'icon'} />
                                                            </figure>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="text">{pnr?.sector}</div>
                                                    </li>

                                                    {/* Route */}
                                                    <li>
                                                        <div className="route fw-semibold">
                                                            {pnr.subpart?.map((inval, i) => (
                                                                <>{formatDate(inval?.departure_date)}<br /></>
                                                            ))
                                                            }

                                                        </div>
                                                    </li>

                                                    {/* Departure Date */}
                                                    <li>
                                                        <div className="">-</div>
                                                    </li>

                                                    {/* Price */}
                                                    <li>
                                                        <div className="">
                                                            {isLogin ?
                                                                <> {pnr?.price > 0 ? `${pnr?.user_currency} - ${pnr?.user_currency == 'PKR'? pnr?.price : (pnr?.price / pnr?.user_cur_value).toFixed(2)}` : 'Fare on call'}</>
                                                                :
                                                                <Button variant={''} className={'basic-btn brandMainColorBg'}
                                                                    onClick={(e) => {
                                                                        handleShow()
                                                                    }}>Login For Price</Button>
                                                            }
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>

                                            {/* Right Side */}
                                            <div className="flg-rght d-flex align-items-center justify-content-around gap-3">

                                                <Button variant={''} className={'brandMainColorBg px-2 py-1 btn text-white'} disabled={pnr?.price <= 0 }
                                                    onClick={(e) => {
                                                        setSelectedPnr({ date: pnr?.date, pnr: pnr?.pnr, price: pnr?.price, updated_at: pnr?.updated_at });
                                                        handleShow()
                                                    }}>Book Now</Button>

                                                {/* Arrow Button */}
                                                <div className="detail-arrow ">
                                                    <button
                                                        type="button"
                                                        className="btn p-0 border-0 bg-transparent"
                                                        onClick={() => setOpenId(openId === `${i}-${index}` ? null : `${i}-${index}`)}
                                                    >
                                                        <i
                                                            className={`fa ${openId === i ? "fa-chevron-up" : "fa-chevron-down"}`}
                                                        ></i>
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Refund Status */}
                                            <div className="red">
                                                <i className="fa fa-close me-1"></i>
                                                Non Refundable
                                            </div>
                                        </div>

                                        {/* Collapse Detail */}
                                        {openId === `${i}-${index}` && (
                                            <div className="dl mt-3">
                                                <div className="card card-body">

                                                    <div className="dtl-inr">

                                                        <div className="flgt-des">
                                                            {pnr.subpart?.map((inval, i) => (
                                                                <ul className="list-unstyled">

                                                                    {/* Flight Name */}
                                                                    <li>
                                                                        <div className="flight-name text-center">
                                                                            <figure className="">
                                                                                <img className={'img-fluid'} src={pnr?.air_line_logo} alt={'icon'} />
                                                                            </figure>

                                                                            <p className="mb-0">
                                                                                {pnr?.air_line} <br />
                                                                                <span className="text-muted">
                                                                                    {inval?.departure_flight_number}
                                                                                </span>
                                                                            </p>
                                                                        </div>
                                                                    </li>

                                                                    {/* Departure */}
                                                                    <li>
                                                                        <div className="flg-dep text-center">
                                                                            <h3 className="mb-0">{inval?.departure_time}</h3>
                                                                            <p className="mb-1 fw-bold">{inval?.departure_from}</p>

                                                                            <span className="txt text-muted small">
                                                                                {inval?.departure_date} <br />
                                                                                Terminal : {inval?.departure_terminal}
                                                                            </span>
                                                                        </div>
                                                                    </li>

                                                                    {/* Duration */}
                                                                    <li className="place-itnr text-center">
                                                                        <p className="duration mb-1"></p>
                                                                        <hr />
                                                                        <p className="duration mt-1"></p>
                                                                    </li>

                                                                    {/* Arrival */}
                                                                    <li>
                                                                        <div className="flg-arr text-center">
                                                                            <h3 className="mb-0">{inval?.arivval_time}</h3>
                                                                            <p className="mb-1 fw-bold">{inval?.arivval_to}</p>

                                                                            <span className="txt text-muted small">
                                                                                {inval?.arivval_date} <br />
                                                                                Terminal : {inval?.arivval_terminal}
                                                                            </span>
                                                                        </div>
                                                                    </li>

                                                                    {/* Extra Info */}
                                                                    <li>
                                                                        <div className="flight-right">
                                                                            <ul className="list-unstyled mb-0 small">
                                                                                <li>Class : Economy (G)</li>
                                                                                <li>Baggage : {pnr?.baggage}+7KG</li>
                                                                                <li>Meals : {`${pnr.meal == 1 ? '' : 'Not'} Included`}</li>
                                                                            </ul>
                                                                        </div>
                                                                    </li>

                                                                </ul>
                                                            ))
                                                            }
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                            {/* </Table> */}
                        </Card.Body>

                    </Card>
                )
            })
                :
                <h4 className='redtext m-0 p-0'>No Ticket Found</h4>
            }
            {(modalShow && isLogin) ? (
                <BookTicket show={modalShow} setShow={setModalShow} selectedPnr={selectedPnr} bookType={'user'} />
            ) : (
                <SigninPopup show={modalShow} setShow={setModalShow} onLoginSuccess={handleLoginSuccess} />
            )}

        </>

    )
}

export default TicketCard2
